import { lazy } from "react";

// Layouts => BlankLayout - PanelLayout  - JustNavLayout(this layout only using in hiring page)

const routes = [
  // Auth Routes =>
  {
    path: "/auth",
    exact: true,
    component: lazy(() => import("../pages/auth")),
    layout: "BlankLayout",
    authNeed: false,
  },
  {
    path: "/logout",
    exact: true,
    component: lazy(() => import("../pages/logout")),
    layout: "PanelLayout",
  },

  // Agents Auth Routes =>
  {
    path: "/webagent/:token",
    exact: true,
    component: lazy(() => import("../pages/auth")),
    layout: "BlankLayout",
    authNeed: false,
  },
  {
    path: "/setplus/auth",
    exact: true,
    component: lazy(() => import("../pages/auth")),
    layout: "BlankLayout",
    authNeed: false,
  },
  {
    path: "/service/:token/:page",
    exact: true,
    component: lazy(() => import("../pages/auth")),
    layout: "BlankLayout",
    authNeed: false,
  },

  // Index Route
  // {
  //   path: "/",
  //   exact: true,
  //   component: lazy(() => import("Pages/panel/index")),
  //   layout: "PanelLayout",
  // },
  // 404 Route
  {
    path: "*",
    exact: false,
    component: lazy(() => import("../pages/notFound")),
    layout: "PanelLayout",
    name: "404",
  },
];

export default routes;
